<template>
	<div
		id="consent-banner"
		role="alert"
		aria-label="Cookie Consent"
		class="fixed bottom-0 z-[1100] w-full from-teal-400 to-sky-600 transition-all duration-500 bg-gradient-[-20deg]"
		:class="
			showBanner
				? 'translate-y-0 opacity-100'
				: 'pointer-events-none translate-y-full opacity-0'
		"
	>
		<div
			class="container flex items-center justify-between gap-4 px-6 py-10 md:justify-center md:gap-20 md:px-10 lg:px-20 lg:py-10 xl:max-w-[900px]"
		>
			<div>
				<p class="text-left text-base text-white md:text-center">
					We use cookies to enhance your experience on our website. By
					continuing to browse, you agree to our use of cookies. Learn
					more in our
					<CarbarLink
						href="/privacy-policy"
						target="_blank"
						text="Privacy Policy"
						font-size="text-base"
						class="inline-block text-white hover:text-gray-300"
						underline-color="decoration-white hover:decoration-gray-300"
					/>
					<span>.</span>
				</p>
			</div>
			<div
				class="group cursor-pointer justify-self-end p-2"
				@click="handleCloseBanner"
			>
				<IconCross class="fill-white hover:fill-gray-300" />
			</div>
		</div>
	</div>
</template>

<script setup lang="ts">
import CarbarLink from '@/components/links/CarbarLink.vue'
import IconCross from '@/assets/svg/common/ico-x.svg'
import { useAfxStore } from '@/stores/afx'

const afxStore = useAfxStore()

const showBanner = computed(() => afxStore.consentReady && afxStore.showBanner)

const handleCloseBanner = () => {
	afxStore.acceptAfxConsent()
}
</script>
